import React from 'react'
import styles from './INDButton.module.scss'
import ADA from '../../../public/assets/ADA.svg'

// This global declaration is to ensure TypeScript recognizes
// the interdeal object on the window
// the script is loaded on the _document.tsx file
declare global {
  interface Window {
    interdeal?: {
      a11y?: {
        openMenu?: () => void
      }
    }
  }
}

// This component is to override the equal web button we are using
// Since we have the INDMenu-btn component, the script hides it's own button
// More info here https://login.equalweb.com/custom-button
const INDButton: React.FC = () => {
  const handleClick = () => {
    // Guard in case the script isn't loaded yet
    if (window?.interdeal?.a11y?.openMenu) {
      window.interdeal.a11y.openMenu()
    }
  }

  return (
    <button id='INDmenu-btn' className={styles.indButton} onClick={handleClick} aria-label='Accessibility menu'>
      <ADA />
    </button>
  )
}

export default INDButton
